module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "query-builder dynamic-form"
  }, [_vm._l((_vm.query), function(search, fieldName) {
    return [_c('query-term', {
      attrs: {
        "fieldName": fieldName,
        "type": search.type,
        "params": search.value,
        "field": _vm.searchSpec.fields[fieldName]
      },
      on: {
        "update:type": [function($event) {
          search.type = $event
        }, function($event) {
          _vm.update()
        }],
        "update:params": [function($event) {
          search.value = $event
        }, function($event) {
          _vm.update()
        }]
      }
    }, [_c('span', {
      staticClass: "remove glyphicon glyphicon-remove",
      on: {
        "click": function($event) {
          _vm.removeField(fieldName)
        }
      }
    })])]
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Add Field:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addFieldName),
      expression: "addFieldName"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.addFieldName = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.addField()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.inactiveFields), function(group) {
    return _c('optgroup', {
      attrs: {
        "label": group.label
      }
    }, _vm._l((group.fields), function(field) {
      return _c('option', {
        key: field.name,
        domProps: {
          "value": field.name
        }
      }, [_vm._v(_vm._s(field.label))])
    }))
  })], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bb7900e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/QueryBuilder.vue
// module id = 1095
// module chunks = 0